import styled from "styled-components";
import { grid } from "../../utils/styled/_grid.style";
import { colors, devices, fonts } from "../../utils/styled/_variables.styled";
import { InfiosKeyFactsItem } from "./KeyFactsItem/KeyFactsItem.style";

export const InfiosKeyFacts = styled.section`
	${grid};
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 96px 0;
	background-color: ${props => props.background};

	* {
		font-family: ${fonts.AeonikPro};
	}

	.heading-2 {
		margin-bottom: 60px;
		color: ${colors.infiosGray};
		font-size: 60px;
		font-weight: 500;
		line-height: 110%;
		letter-spacing: -1.2px;

		@media ${devices.tabletToDesktop} {
			margin-bottom: 40px;
		}

		@media ${devices.mobile} {
			margin-bottom: 40px;
			font-size: 38px;
			letter-spacing: -0.77px;
		}
	}

	.key-facts-subtitle {
		margin-bottom: 20px;
		color: ${colors.infiosGray};
		font-size: 19px;
		font-weight: 400;
		line-height: 120%; /* 24px */
		letter-spacing: 0.6px;

		@media ${devices.tabletLarge} {
			margin-bottom: 32px;
		}

		@media ${devices.mobile} {
			margin-bottom: 20px;
		}
	}

	.key-facts-wrapper {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 45px;

		@media ${devices.mobile} {
			grid-template-columns: 1fr;
			gap: 12px;
		}

		section {
			margin: 0;
			background-color: ${colors.bluegray};
			border-radius: 11px;
			padding: 32px;

			span {
				font-family: ${fonts.AeonikMono};
				text-transform: uppercase;
			}

			@media ${devices.tabletToDesktop} {
				min-height: 250px;
			}
			@media ${devices.mobile} {
				min-height: 220px;
			}
		}

		${InfiosKeyFactsItem} {
			height: 100%;
		}
	}

	@media ${devices.tabletToDesktop} {
		padding-top: 100px;
		padding-bottom: 100px;
	}

	@media ${devices.mobile} {
		padding-top: 64px;
		padding-bottom: 64px;
	}

	.limiter {
		display: flex;
		width: 100%;
		max-width: 644px;
		flex-basis: 45%;
		flex-grow: 1;
		opacity: 0;
	}
`;
